import { useEffect } from 'react'

export function useMetaPixel() {
  useEffect(() => {
    // Safely initialize fbq on window
    const w = window as any
    if (w.fbq) return

    const n: any = (w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Load the FB pixel script safely by appending to head
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Init and track
    w.fbq('init', '904978025482552')
    w.fbq('track', 'PageView')

    // Add noscript fallback
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src =
      'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1'
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script)
      }
      if (document.body.contains(noscript)) {
        document.body.removeChild(noscript)
      }
    }
  }, [])
}
